import { type AnyDynamicModalData } from '@/common/types/modal';

import { componentsMap } from './config';

const DynamicModal = ({
  name,
  props,
}: AnyDynamicModalData): JSX.Element | null => {
  const Component = componentsMap[name];

  if (!Component) {
    return null;
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  return <Component {...(props as any)} />;
};

export { DynamicModal };
